module.exports = __webpack_public_path__ + "img/img6.4eaff988.jpg";